import React, { useEffect, useState } from "react";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import FameWallNaati from "../components/Frontend/FameWallNaati";
import { Link, useNavigate } from "react-router-dom";
import VideoTestimonial from "../components/Frontend/VideoNaatiTestimonial";
import { Helmet } from "react-helmet";

// import Frame1 from "../assets/images/public-pages/Frame1.svg"
// import Frame2 from "../assets/images/public-pages/Frame2.svg"
// import Frame3 from "../assets/images/public-pages/Frame3.svg"
// import Frame4 from "../assets/images/public-pages/Frame4.svg"

// import bannerImage from "../assets/images/public-pages/natticcl-parramatta.png"
import bannerImage from "../assets/images/public-pages/New-Public-banner.webp"
import naatiOnline from "../assets/images/public-pages/naaticcl-para-online.png"  

import ExpertTrainers from "../assets/images/public-pages/Expert-Trainers.svg";
import OnlineFlexibility from "../assets/images/public-pages/Online-Flexibility.svg";
import ProvenSuccess from "../assets/images/public-pages/Proven-Success.svg";
import PersonalizedFeedback from "../assets/images/public-pages/Personalized-Feedback.svg";
import ComprehensiveResources from "../assets/images/public-pages/Comprehensive-Resources.svg";

import Report from "../assets/images/public-pages/report.svg";

import TimeIcon from "../assets/images/public-pages/Time-icon.png";
import FeeIcon from "../assets/images/public-pages/FeeIcon.png";
import DiscussionIcon from "../assets/images/public-pages/DiscussionIcon.png";
import QuestionsIcon from "../assets/images/public-pages/QuestionsIcon.png";
import SupportIcon from "../assets/images/public-pages/SupportIcon.png";
import ResourceIcon from "../assets/images/public-pages/ResourceIcon.png";
import MaterialsIcon from "../assets/images/public-pages/MaterialsIcon.png";
import HighestIcon from "../assets/images/public-pages/HighestIcon.png";
import ExperiencedIcon from "../assets/images/public-pages/ExperiencedIcon.png";

import NaatiCclSecondImage from "../assets/images/public-pages/naati-ccl-on-campus.png"
import TickIcon from "../assets/images/public-pages/tick-circle.svg"

import BannerHeader from "components/PublicPagesReusable/BannerHeader";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import InfoSection from "components/PublicPagesReusable/InfoSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import OnlinePricingTable from "components/PublicPagesReusable/OnlinePricingTable";
import NaatiCourseCards from "components/PublicPagesReusable/NaatiCourseCards";
import ExamSkillsSection from "components/PublicPagesReusable/ExamSkillsSection";
import AppPromoSection from "components/PublicPagesReusable/AppPromoSection";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import ComparisonSection from "components/PublicPagesReusable/ComparisionSection";
import ContentImageAndCardSection from "components/PublicPagesReusable/ContentImageAndCardSection";
import PteAppBanner from "components/PublicPagesReusable/PteAppBanner";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import HeroSectionUpdated from "components/PublicPagesReusable/HeroSectionUpdated";
import { PricingCard } from "./Home";

const Naati = () => {
  const navigate = useNavigate();
  const [isActive, setIsActive] = useState(false);

  const handleClick = () => {
    setIsActive((prev) => !prev);
  };

  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    adaptiveHeight: true,
    autoplaySpeed: 5000,
  };

  const bannerTitle = () => {
    return (
      <h1 className="FS56FW500 top-section-text">
        Secure Your Australian Future:<br/>
        <span className="text-success fw-600">Parramatta's Best NAATI CCL<br/> Coaching Centre</span>
      </h1>
    );
  };

    const heroData = {
    badge: "50,000+ Students' Success Stories",
    title: bannerTitle,
    subtitle: "Where expert instruction meets proven success, your pathway to permanent residency starts here.",
    btn_prepration: { text: "Begin NAATI CCL Training", onClick: () => window.location.href = `${import.meta.env.VITE_NAATI_URL}auth/register` },
    // btn_outline: { text: "Free Mock Test", variant: "outline", onClick: () => window.location.href = '/auth/register' },
    users: [
      "/images/web-new-images/new-content-slider/User-01.svg",
      "/images/web-new-images/new-content-slider/Pritam.svg",
      "/images/web-new-images/new-content-slider/Karthik-B.svg",
      "/images/web-new-images/new-content-slider/RamimRahman-demo.svg",
      "/images/web-new-images/new-content-slider/SapnaPandey-demo.svg",
    ],
    trustText: "Trusted by 50,000+ students'",
    profile: {
      image: "/images/web-new-images/new-content-slider/Varun-sir-hero.webp",
      stats: [
        { value: "50K+", label: "STUDENTS" },
        { value: "95%", label: "SUCCESS RATE" },
        { value: "10+", label: "LOCATIONS" }
      ]
    },
    bottomStats: [
      { value: "8",highlight:'+', label: "Years of NAATI Expertise" },
      { value: "30", highlight:'+', label: "Countries Served" },
      { value: "12", highlight:'+', label: "Languages" },
      { value: "/5", highlight:'4.9', label: "Students' Rating" }
    ]
  };

const images = [
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-1.jpeg",
      alt: "score-1",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-2.jpeg",
      alt: "score-2",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-3.jpeg",
      alt: "score-3",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-4.jpeg",
      alt: "score-4",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-5.jpeg",
      alt: "score-5",
    },
    {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-6.jpeg",
      alt: "score-6",
    },
   {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-7.jpeg",
    alt: "score-7",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-8.jpeg",
    alt: "score-8",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-9.jpeg",
    alt: "score-9",
  },
  {
    src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-10.jpeg",
    alt: "score-10",
  },
  {
      src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-11.jpeg",
      alt: "score-11",
    },
  //   {
  //     src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-12.png",
  //     alt: "score-12",
  //   },
  //   {
  //     src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-13.png",
  //     alt: "score-13",
  //   },
  //   {
  //     src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-14.png",
  //     alt: "score-14",
  //   },
  //   {
  //     src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-15.png",
  //     alt: "score-15",
  //   },
  //   {
  //     src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-16.png",
  //     alt: "score-16",
  //   },
  //  {
  //   src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-17.png",
  //   alt: "score-17",
  // },
  // {
  //   src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-18.png",
  //   alt: "score-18",
  // },
  // {
  //   src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-19.png",
  //   alt: "score-19",
  // },
  // {
  //   src: "/images/web-new-images/emojis/Updated/NAATI-CCL-Scorecards/Scorecard-20.png",
  //   alt: "score-20",
  // },
  ];

  const heroDescriptionSection = () => {
    return (
      <div className="text-center d-flex align-items-center justify-content-center flex-column">
        <p className="sub-title text-center FS16FW500 w-75">
          Achieve your dream of passing the NAATI CCL exam with our expertly
          tailored training at Parramatta's premier NAATI CCL Classes in
          Parramatta preparation centre.
        </p>
        <br />
        <p className="sub-title text-center FS16FW500 w-75">
          Build confidence in your language interpretation skills, secure five
          bonus points for your Australian PR application, and excel with our
          comprehensive NAATI Classes in Parramatta training program designed
          for aspirants, students, and immigrants.
        </p>
      </div>
    );
  };

   const skillAreaTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        <span className="text-success FS40FW600">Why Choose Our Take <br /> NAATI CCL </span> Training Centre in <br /> Parramatta?</h3>
    )
  }

  const skillAreaTitle2 = () => {
    return (
      <h3 className="top-section-text mb-4 FS40FW600">Our <span className="text-success FS40FW600"> NAATI CCL </span> Training <br /> Program in Parramatta</h3>
    )
  }

  const lifestyleCards = [
        {
          title: "Learn From Certified Trainers",
          text: "Get insights and strategies from NAATI-accredited professionals who specialize in NAATI CCL Parramatta standards.",
          color: "rgb(255 255 255 / 0%)",
          img: ExpertTrainers,
          hoverColor: '#007AFF',
          borderColor:'rgba(255, 255, 255, 0.24)'
        },
        {
          title: "Personalized Feedback",
          text: "Identify your weaknesses and improve your performance with expert guidance.",
          color: "rgb(255 255 255 / 0%)",
          img: PersonalizedFeedback,
          hoverColor:'#FF2D55',
          borderColor:'rgba(255, 255, 255, 0.24)'
        },
        {
          title: "Flexible Learning Options",
          text: "Choose between our intensive NAATI CCL Classes in Parramatta in-person sessions or online training.",
          color: "rgb(255 255 255 / 0%)",
          img: OnlineFlexibility,
          hoverColor: '#FFCC00',
          borderColor:'rgba(255, 255, 255, 0.24)'
        },
        {
          title: "Comprehensive Resources",
          text: "Access up-to-date vocabulary lists, dialogue exercises, and mock tests through our NAATI Classes in Parramatta program.",
          color: "rgb(255 255 255 / 0%)",
          img: ComprehensiveResources,
          hoverColor: '#34C759',
          borderColor:'rgba(255, 255, 255, 0.24)'
        },
        {
          title: "Proven Track Record",
          text: "Join 50,000+ of successful students who have earned their Australian PR points with our support.",
          color: "rgb(255 255 255 / 0%)",
          img: ProvenSuccess,
          hoverColor: '#FF9500',
          borderColor:'rgba(255, 255, 255, 0.24)'
        },
      ];

      const naatiCourseCards = [
        {
          title: "Online Intensive Course",
          features: [
            "10 Online Sessions + 1 hour consultation",
            "Flexible scheduling for busy professionals accessing NAATI Classes in Parramatta remotely",
            "Access from anywhere with internet connection",
            "Same quality instruction as NAATI CCL Parramatta in-person classes",
          ],
        },
        {
          title: "8 - Weeks Intensive Course",
          isPopular: true,
          features: [
            "Online 1-1 session course",
            "In-person training at our NAATI CCL Classes in Parramatta centre",
            "Comprehensive face-to-face instruction",
            "Small class sizes for personalized attention",
          ],
        },
        {
          title: "Both programs are designed to address common challenges NAATI CCL aspirants face",
          titleLarge: true,
          features: [
            "Limited access to reliable preparation materials",
            "Busy schedules preventing consistent study",
            "Lack of practice opportunities",
            "Fear of failing the exam and missing out on PR",
          ],
        },
      ];

      const comparisionData = []

       const comparisionTopText = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Start Your <span className="text-success FS40FW600">On Campus </span>  <br /> Coaching Plan <br />
        
      </h3>
    )
  } 

  const appPromotionSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Language Academy </span>Mobile Application:<br/>
        Your NAATI CCL Parramatta’s Prep On-The-Go
      </h3>
    );
  };

  const rightDescriptionSecondHeading = () => {
    return (
      <p className="top-section-text FS18FW400">
        <span className="text-black FS18FW400 fw-700"> Test Duration -</span> The total test time is approximately 20–30 minutes, including instructions.
      </p>
    )
  } 

  const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        What We Offer At Our {" "}
        <span className="text-success FS40FW600">NAATI <br/>Classes</span> in Parramatta Training <br /> Centre        
      </h3>
    )
  }

  const contentSectionAchieve = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Achieve{" "}<span className="text-success FS40FW600">NAATI CCL <br/>Success</span> With Focused <br />Skill-Building        
      </h3>
    )
  }

  const contentSectionChoice = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Why Language Academy is<br/><span className="text-success FS40FW600">Parramatta’s Right Choice</span> For <br />NAATI CCL        
      </h3>
    )
  }

  const faqQuestions = [
    {
      question: "How long does it take to prepare for the NAATI CCL exam with NAATI CCL Classes in Parramatta?",
      answer: "Most students need 4-6 weeks of consistent preparation, but with our intensive 8-week NAATI Classes in Parramatta course, you'll be fully prepared."
    },
    {
      question: "Do you offer both online and in-person NAATI CCL Parramatta classes?",
      answer: "Yes! We offer both an 8-week intensive course with up to 4 classes per week at our NAATI CCL Classes in Parramatta training centre, and a 10-session online intensive course."
    },
    {
      question: "What languages do you offer NAATI CCL preparation for?",
      answer: "We offer preparation in 12 languages: Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada."
    },
    {
      question: "How can I book a free demo class at your NAATI Classes in Parramatta centre?",
      answer: "You can call us on +61 426230061 or email us at info@languageacademy.com.au to schedule your free demo NAATI CCL Parramatta class."
    },
    {
      question: "What makes your NAATI CCL Classes in Parramatta training centre different?",
      answer: "We provide personal 1-on-1 feedback, intensive vocabulary building, online audio dialogues, and regular mock exams under actual exam conditions at our NAATI CCL Parramatta facility"
    },
    {
      question: "When was the NAATI CCL exam introduced?",
      answer: "The NAATI CCL exam was introduced in July 2018 and has rapidly gained prominence among Australian PR aspirants."
    },
    {
      question: "What is included in your NAATI Classes in Parramatta training programs?",
      answer: "Our NAATI CCL Parramatta programs include intensive vocabulary, personal 1-on-1 feedback, online audio dialogues, and regular mock exams under exam conditions. "
    }
  ];

  return (
      <React.Fragment>
        <Helmet>
          <title>NAATI CCL Coaching Classes in Parramatta | LA Language Academy</title>
          <meta name="description" content="Join LA Language Academy's NAATI coaching classes in Parramatta. Achieve certification with expert training and comprehensive study materials. Contact now!" />
          <meta name="robots" content="index, follow" />
          <link rel="canonical" href={`https://www.languageacademy.com.au/naati-coaching-classes-parramatta`} />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:site" content="@languageacademy" />
          <meta name="twitter:title" content="NAATI CCL Coaching Classes in Parramatta | LA Language Academy" />
          <meta name="twitter:description" content="Join LA Language Academy's NAATI coaching classes in Parramatta. Achieve certification with expert training and comprehensive study materials. Contact now!" />
          <meta name="twitter:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta name="twitter:image:alt" content="LA Language Academy Logo" />
          <meta property="og:url" content={`https://www.languageacademy.com.au/naati-coaching-classes-parramatta`} />
          <meta property="og:type" content="website" />
          <meta property="og:title" content="NAATI CCL Coaching Classes in Parramatta | LA Language Academy" />
          <meta property="og:description" content="Join LA Language Academy's NAATI coaching classes in Parramatta. Achieve certification with expert training and comprehensive study materials. Contact now!" />
          <meta property="og:image" content={`https://www.languageacademy.com.au/images/logol.png`} />
          <meta property="og:image:alt" content="LA Language Academy Logo" />
          <meta property="og:width" content="1200" />
          <meta property="og:height" content="630" />

          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: [
                {
                  "@type": "Question",
                  name: "How long does it take to prepare for the NAATI CCL exam with your NAATI CCL training?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Most students need 4-6 weeks of consistent NAATI CCL coaching preparation, but it may vary depending on your current proficiency and practice time.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What languages do you offer NAATI CCL online course preparation in?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "We offer NAATI online course preparation in 12 languages: Hindi, Punjabi, Urdu, Nepali, Bangla, Tamil, Telugu, Malayalam, Gujarati, Sinhalese, Marathi and Kannada.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Can I reschedule my NAATI CCL Online Classes sessions?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we offer flexible scheduling options for our NAATI CCL online coaching to fit your availability, making online learning even more convenient.",
                  },
                },
                {
                  "@type": "Question",
                  name: "How does the NAATI CCL mobile app help with NAATI CCL training centre preparation?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Our app includes 2000+ vocabulary words, 75 practice dialogues for each language, mock tests that simulate the real exam environment through our NAATI CCL coaching system.",
                  },
                },
                {
                  "@type": "Question",
                  name: "What score do I need to pass the NAATI CCL exam?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "You need to score a minimum of 29 out of 45 in each dialogue to pass the NAATI CCL exam successfully.",
                  },
                },
                {
                  "@type": "Question",
                  name: "Do you provide practice materials for previous exam questions?",
                  acceptedAnswer: {
                    "@type": "Answer",
                    text: "Yes, we have curated over 1000+ questions from previous exams to help you practice the most commonly asked questions.",
                  },
                },
              ],
            })}
          </script>
        </Helmet>
        <div className="new-design">
        <Header />
        {/* <BannerHeader btnText={"Enroll in our Program today"} btnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`} title={bannerTitle}  subTitle={subTitleSection} backgroundColor='#182A4F' textColor="white" middleSection={() => {
                  return (  <div style={{paddingBottom: '232px'}} className="banner-img-wrapper">
                      <img
                    className="banner-img"
                    src={bannerImage}
                    alt="LA"  
                  />
                  </div>)
                }} /> */}
          <HeroSectionUpdated data={heroData} />      
                <div className="fame-wall off-white">
                  <ReusableHomePageSlider images={images} />
                </div>

             <div className="d-flex align-items-center gap-4 flex-column pb-4 off-white">
                  {heroDescriptionSection()}
                  <ButtonComp link={`/contact`} btnText={"Book Your Free Trial Class"} />
        </div>   

        <InfoSection
                  title="What Is The NAATI CCL Exam?"
                  subtitle="Your Key To Australian Permanent Residency"
                  description="The NAATI Credentialed Community Language (CCL) exam is an essential test designed to assess your ability to translate and interpret between English and your preferred native language."
                  subdescription="By succeeding in the NAATI CCL exam, you can claim five bonus points on your point-based visa application."
                  buttonText="Start Your NAATI CCL Prep Journey Today"
                  buttonAction={() => window.open(`${import.meta.env.VITE_NAATI_URL}auth/register`, '_blank')}
                  image={naatiOnline}
                  multiImageCaption={["Since its introduction in July 2018, NAATI CCL has rapidly gained prominence among aspirants seeking permanent residency in Australia.<br/><br/>This exam assesses candidates' performance based on their ability to comprehend and translate English dialogues to their chosen LOTE (Language Other Than English) and vice versa"]}
                  rightDescriptionSecondHeading={rightDescriptionSecondHeading}
                  rightDescriptionSecond="Scoring System"
                  
                  featuresSecond={[
                    "Each dialogue is marked out of 45 marks.",
                    "The total test score is 90 marks.",
                    "To pass, you must: Score at least 29 marks in each dialogue, AND",
                    "Achieve a minimum total score of 63 out of 90.",
                  ]}

                   rightTitle="NAATI CCL Test Pattern"
                   features={[
                    "The test consists of 2 recorded dialogues",
                    "Each dialogue is approximately 300 words in total.",
                    "The dialogues are divided into segments (usually 35 words or less per segment).",
                    "You must interpret each segment consecutively after hearing it.",
                  ]}
                />

                 <SkillAreas
          skillAreaTitle={skillAreaTitle}
          lifestyleCards={lifestyleCards}
          showInSlider={false}
          btnText={"Enroll For CCL Training in Parramatta Today"}
          btnLink="/contact"
          skillSubtitle={"Are you searching for the top NAATI CCL Classes in Parramatta training centre that can help you accomplish your dreams?"}
          skillToptitle="At Language Academy, Parramatta's trusted NAATI Classes in Parramatta preparation centre, we provide:"
          MiddleInfoSection={[
            "You're in the right place! Do you want to grab these five CCL points for Australia PR, but are confused about how to optimize your NAATI exam preparation?",
            "With a proper strategy, by following the right NAATI test preparation course, and practicing regularly, you can take your exam performance to peak level.",
          ]}
        />

        <NaatiCourseCards
          skillAreaTitle={skillAreaTitle2}
          cards={naatiCourseCards}
          btnText={"Choose Your Preferred Training Format"}
          btnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`}
        />

        <ExamSkillsSection
          customStyle={true}
          contentSection={contentSection}
          showInSlider={false}
          description={`Our comprehensive NAATI CCL Parramatta preparation program <br/> includes:`}
          ctaText="Experience Our Comprehensive Approach"
          onCtaClick={() => window.open(`${import.meta.env.VITE_NAATI_URL}auth/register`, '_blank')}
          cards={[
            {
              icon: Report,
              title: "Intensive Vocabulary Building",
              content:`
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS16FW500'>Comprehensive word lists for each language</span>
                </li>
                <li>
                  <span class='FS16FW500'>Context-based vocabulary exercises specific to NAATI CCL Classes in Parramatta</span>
                </li>
                <li>
                  <span class='FS16FW500'>Cultural nuances and terminology specific to NAATI CCL</span>
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: Report,
              title: "Personal 1-ON-1 Feedback",
              content:`
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS16FW500'>Individual assessment of your interpretation skills</span>
                </li>
                <li>
                  <span class='FS16FW500'>Customized improvement strategies through our NAATI Classes in Parramatta program</span>
                </li>
                <li>
                  <span class='FS16FW500'>Direct interaction with certified trainers</span>
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: Report,
              title: "Online Audio Dialogues",
              content: `
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS16FW500'>Extensive library of practice recordings</span>
                </li>
                <li>
                  <span class='FS16FW500'>Varied accents and speaking speeds</span>
                </li>
                <li>
                  <span class='FS16FW500'>Real exam-style dialogue formats</span>
                </li>
                </ul>
                </div>
              `
            },
            {
              icon: Report,
              title: "Regular Mock Exams Under Exam Conditions",
              content:`
                <div>
                <ul class='feature-list plus-sans'>
                <li>
                  <span class='FS16FW500'>Simulated test environment at our NAATI CCL Parramatta centre</span>
                </li>
                <li>
                  <span class='FS16FW500'>Timed practice sessions</span>
                </li>
                <li>
                  <span class='FS16FW500'>Detailed performance analysis and feedback</span>
                </li>
                </ul>
                </div>
              `
            }
          ]}
        />

        <ExamSkillsSection
          contentSection={contentSectionAchieve}
          description={`Excelling in the NAATI CCL exam requires honing translation,<br/> interpretation, & time management abilities. Here's how we support<br/> your journey at our NAATI CCL Classes in Parramatta training centre:`}
          ctaText="Sign Up For Our Training Now"
          onCtaClick={() => window.open(`${import.meta.env.VITE_NAATI_URL}auth/register`, '_blank')}
          cards={[
            {
                          icon: Report,
                          title: "Listening Skills",
                          content:  `
                            <div>
                            <ul class='feature-list plus-sans'>
                            <li>
                              <span class='FS18FW400 fw-700 text-black'>What It Tests</span><br/>
                              <span class='FS16FW500'>Comprehension of language tones, accents, and cultural subtleties</span>
                            </li>
                            <li>
                              <span class='FS18FW400 fw-700 text-black'>Our Method</span><br/>
                              <span class='FS16FW500'>Audio-based exercises to sharpen your listening and cultural awareness</span>
                            </li>
                            </ul>
                            </div>
                          `
                        },
                        {
                          icon: Report,
                          title: "Translation & Interpretation",
                          content: `
                            <div>
                            <ul class='feature-list plus-sans'>
                            <li>
                              <span class='FS18FW400 fw-700 text-black'>What It Tests</span><br/>
                              <span class='FS16FW500'>Your ability to accurately and fluently interpret dialogues</span>
                            </li>
                            <li>
                              <span class='FS18FW400 fw-700 text-black'>Our Method</span><br/>
                              <span class='FS16FW500'>Practice with real-world dialogues, vocabulary building, & structured mock tests</span>
                            </li>
                            </ul>
                            </div>
                          `
                        },
                        {
                          icon: Report,
                          title: "Time Management",
                          content: `
                            <div>
                            <ul class='feature-list plus-sans'>
                            <li>
                              <span class='FS18FW400 fw-700 text-black'>What It Tests</span><br/>
                              <span class='FS16FW500'>Staying calm and accurate under pressure</span>
                            </li>
                              <li>
                                <span class='FS18FW400 fw-700 text-black'>Our Method</span><br/>
                                <span class='FS16FW500'>Training in efficient time utilization while maintaining focus</span>
                            </li>
                            </ul>
                            </div>
                          `
                        }
          ]}
          bottomText={"Prepare smarter and give your best on exam day with our expert techniques."}
        />

        <ExamSkillsSection
          contentSection={contentSectionChoice}
          ctaText="Join Our Community Of Successful Students"
          onCtaClick={() => window.open(`${import.meta.env.VITE_NAATI_URL}auth/register`, '_blank')}
          cards={[
            {
              icon: ExperiencedIcon,
              title: "Certified Trainers",
              content: `
                <div>Work with instructors who know the ins and outs of the NAATI CCL exam and have extensive experience in Parramatta..</div>
              `
            },
            {
              icon: HighestIcon,
              title: "Exceptional Results",
              content: `
                <div>Join over 50,000 students who have successfully passed the exam and earned their PR points through our proven NAATI CCL Classes in Parramatta methods.</div>
              `
            },
            {
              icon: MaterialsIcon,
              title: "Free Study Resources",
              content: `
                <div>Access proven questions, practice, and vocabulary lists specifically designed for NAATI CCL Parramatta success.</div>
              `
            },{
              icon: ResourceIcon,
              title: "Latest Prep Tool",
              content: `
                <div>Study smarter with our cutting-edge mobile app and online platform accessible anytime for NAATI students.</div>
              `
            },{
              icon: SupportIcon,
              title: "24/7 Support",
              content: `
                <div>Receive guidance from our team whenever you need it, whether you're studying at our Parramatta centre or online.</div>
              `
            },{
              icon: DiscussionIcon,
              title: "Discussion Sessions",
              content: `
                <div>Personalized strategies based on your strengths and weaknesses identified during our assessment sessions.</div>
              `
            },{
              icon: FeeIcon,
              title: "Affordability",
              content: `
                <div>Flexible fee plans designed for every budget, making quality NAATI CCL training accessible to all.</div>
              `
            },{
              icon: Report,
              title: "Exam Simulation",
              content: `
                <div>Mock tests that recreate real exam conditions at our fully-equipped NAATI CCL Parramatta training facility.</div>
              `
            }
          ]}
        />

        <AppPromoSection
          // titleHighlight="Language Academy"
          // title="Mobile Application: Your NAATI CCL Parramatta’s Prep On-The-Go"
          title={appPromotionSection()}
          subtitle="Prepare for the NAATI CCL exam on your own terms with our powerful mobile application:"
          featuresLeft={[
            {
              icon: "/images/web-new-images/Vocabulary.svg",
              title: "Vocabulary Bank",
              description: "Access 2000+ words in seven essential categories, available with translations for all supported languages.",
            },
            {
              icon: "/images/web-new-images/Mock-Test.svg",
              title: "Realistic Mock Tests",
              description: "Practice in an environment that mimics the actual test, whether you're at our NAATI CCL Classes in Parramatta centre or studying remotely.",
            },
          ]}
          featuresRight={[
            {
              icon: "/images/web-new-images/Comprehensive.svg",
              title: "Practice Dialogues",
              description: "Learn with 80+ dialogues inspired by previous exams, complete with expert sample answers from our NAATI Classes in Parramatta program.",
            },
            {
              icon: "/images/web-new-images/Last-Minute.svg",
              title: "Last-Minute Booster Packages",
              description: "Build your confidence with targeted tips and exercises designed for speedy results.",
            },
          ]}
          mobileImg="/images/web-new-images/emojis/Updated/PromoSection.png"
          ctaText="Download Our App and Start Practicing"
          onCtaClick={() => window.open(import.meta.env.VITE_NAATI_URL + "naati-app-lp", '_blank')}
        />

        <div className="custom-container py-2 d-none">
        <ComparisonSection
                          data={comparisionData}
                          comparisionTopText={comparisionTopText}
                          comparisionDescriptionText={`Choose between our affordable NAATI course fee options:`} />
                  <ContentImageAndCardSection
                    title="Campus Coaching"
                    subtitle="Get the ultimate preparation with live expert guidance."
                    listItems={[
                      { 
                        title: "In-Person Training", 
                        description: "Attend classes at one of our 12 locations across Australia, India, and Nepal" 
                      },
                      { 
                        title: "One-on-One Sessions", 
                        description: "Personal coaching tailored to your specific challenges and goals" 
                      },
                      { 
                        title: "Intensive Workshops", 
                        description: "Participate in specialized sessions targeting high-value exam components" 
                      },
                      { 
                        title: "Extended Support", 
                        description: "Continuous guidance until you achieve your required score" 
                      },
                      { 
                        title: "Exam Booking Assistance", 
                        description: "Help with scheduling and preparing for your test day" 
                      },
                    ]}
                    cardBtnText="ENROLL IN OUR PROGRAM TODAY"
                  cardBtnLink={`${import.meta.env.VITE_NAATI_URL}auth/register`}
                    image={NaatiCclSecondImage}
                    tickIcon={TickIcon}
                  />
                </div>
         <div className="container py-5">
          <div className="text-center">
            {comparisionTopText()}
            <p className="quote-para FS18FW400 fw-500 py-4">Choose between our affordable NAATI course fee options:</p>
          </div>
          <div className="row justify-content-center">

            <PricingCard
              title="PACKAGE 1"
              subtitle="Online Coaching"
              price="249"
              // currency="AUD / 2months"
              features={[
                "Live Virtual Classes",
                "Personalized Feedback",
                "Direct Trainer Access",
                "Priority Support",
                // "1 Mock test with Scorecard & Feedback on Improvement",
                // { text: "1 Mock test with Scorecard & Feedback on Improvement", active: false },
              ]}
              description={'Get expert guidance with Online Coaching.'}
              btaBtnText={"Start Your Plan"}
              ctaLink={`${import.meta.env.VITE_NAATI_URL + 'auth/register'}`}
            />

            <PricingCard
              title="PACKAGE 2"
              subtitle="Campus Coaching"
              price="249"
              isPopular={true}
              dark={true}
              features={[
                "In-Person NAATI Coaching",
                "One-on-one Sessions",
                "Intensive Workshops",
                "Extended Support",
                "Exam Booking Assistance",
              ]}
              description={'In-person training with expert instructors.'}
              btaBtnText={"Start Your Plan"}
              ctaLink={`${import.meta.env.VITE_NAATI_URL + 'auth/register'}`}
            />

            <PricingCard
              title="MOBILE"
              subtitle="NAATI Practice App"
              price="Free"
              isFree={true}
              currency="to download"
              features={[
                "Available on iOS & Android",
                "2,000+ key English vocabulary words",
                "80+ dialogues with sample answers",
                "Mock tests with model responses",
                "Dedicated last-minute revision",
              ]}
              description={'Practice on the go'}
              ctaLink={`${import.meta.env.VITE_NAATI_URL + "naati-app-lp"}`}
              // img="/images/web-new-images/new-dark-arrow.svg"
            />

          </div>
        </div>        
                
                <AppBannerCustom
            appName="NAATI"
            description="LA CCL"
            mobileImage="/images/web-new-images/HomePageImage/NAATI-app.png"
            playStoreLink={`${import.meta.env.VITE_NAATI_ANDROID_APP_URL}`}
            appStoreLink={`${import.meta.env.VITE_NAATI_IOS_APP_URL}`}
          />

                        <FaqSection questions={faqQuestions}/>

        <Footer />
        </div>
      </React.Fragment>
    );
};

export default Naati;
